import * as R from 'remeda'

const ESCAPE_MAP: { [key: string]: string } = {
  '\\': String.raw`\\`, // Escape backslashes
  '\n': String.raw`\n`, // Escape newlines
  '\t': String.raw`\t`, // Escape tabs
  '"': String.raw`\"`, // Escape quotes
}

const UNESCAPE_MAP = R.invert(ESCAPE_MAP)

const getRegexMatchingAllKeys = (map: Record<string, string>): RegExp => {
  return new RegExp(
    `${Object.keys(map)
      .map(str => {
        // Escape special characters for regex
        return str.replaceAll(/[\\^$.*+?()[\]{}|]/g, String.raw`\$&`)
      })
      .join('|')}`,
    'g'
  )
}

const escapeRegex = getRegexMatchingAllKeys(ESCAPE_MAP)
const unescapeRegex = getRegexMatchingAllKeys(UNESCAPE_MAP)

/**
 * Escapes backslashes, newlines and quotes in the given content.
 *
 * @param content The input string to escape.
 * @returns The escaped string.
 */
export const escapeEvent = (content: string): string => {
  return content.replaceAll(escapeRegex, match => ESCAPE_MAP[match] || match)
}

/**
 * Unescapes backslashes, newlines and quotes in the given content.
 *
 * @param content The input string to unescape.
 * @returns The unescaped string.
 */
export const unescapeEvent = (content: string): string => {
  return content.replaceAll(unescapeRegex, match => UNESCAPE_MAP[match] || match)
}
